import React, { createContext, useContext, useEffect, useState } from 'react';
import { translations, languages } from './translations';

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    const saved = localStorage.getItem('moonlit_lang');
    if (saved && translations[saved]) return saved;
    const browser = navigator.language.split('-')[0];
    return translations[browser] ? browser : 'en';
  });

  useEffect(() => {
    localStorage.setItem('moonlit_lang', lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = translations[lang] || translations.en;

  return (
    <LanguageContext.Provider value={{ lang, setLang, t, languages }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLanguage = () => useContext(LanguageContext);
